/**
 * 将给定的金钱数额格式化为货币字符串
 * @param value 要格式化的金钱数额
 * @param symbol 金钱符号, 默认为￥
 * @example $currency(318295.43) => '￥318, 295.43'
 */
export default function (value: string | number = 0, symbol: string = '￥'): string{
	var rex = /\d{1,3}(?=(\d{3})+$)/g;
	return (+String(value).replace(/[^-\d\.]/g, '') || 0)
		.toString()
		.replace(/^(-?)(\d+)((\.\d+)?)$/, function (s, s1, s2, s3){
			return symbol + s1 + s2.replace(rex, '$&,') + (s3 || '.00');
		});
}
